module.exports = __webpack_public_path__ + "img/icon-moon.3dd45858.svg";